import React, { Component, PropTypes } from 'react'
import { Modal, Button } from 'react-bootstrap'

export function getMessage(accessType, contact) {
  if (accessType === 'user') {
    return (
      <div>
        <p>
          Please inform the caller that their reservation cannot be processed at
          this time, a volunteer from iii welcome center in Tennessee will reach
          out to them shortly.
        </p>
        <p>
          Take their name and number and inform iii office to help process this
          stay request.
        </p>
        <p>Error message: ErrFlag01</p>
      </div>
    )
  } else if (accessType === 'admin') {
    return `${contact.FirstName} ${contact.LastName} has been flagged 
      ${contact.Flag__c}. Please make sure his stay is approved before booking.`
  } else {
    return (
      'Your request cannot be processed at this time, please call ' +
      '931 668 1900 for help.'
    )
  }
}

export default class FlaggedContactModal extends Component {
  static propTypes = {
    accessType: PropTypes.string,
    contact: PropTypes.object,
    onExitBookingClick: PropTypes.function,
    onContinueClick: PropTypes.function
  }
  render() {
    const {
      accessType,
      contact,
      onExitBookingClick,
      onContinueClick
    } = this.props

    return (
      <Modal show>
        <Modal.Body>
          <strong>{getMessage(accessType, contact)}</strong>
        </Modal.Body>
        <Modal.Footer>
          {accessType === 'admin' ? (
            <Button bsStyle='warning' onClick={onContinueClick}>
              Continue booking
            </Button>
          ) : null}
          <Button bsStyle='danger' onClick={onExitBookingClick}>
            Exit booking
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/FlaggedContactModal.js